import updateQuickshops from './updateQuickshop';
import { initQuickshopDesktopAutoClick } from './desktopAutoClick';
/** Wires quickshop DOM glue (modal, radios, analytics) and desktop multi-size auto-add. */
export function initQuickshop() {
    updateQuickshops();
    initQuickshopDesktopAutoClick();
}
